/**
 * Storage Keys
 * 로컬 스토리지 키 상수
 */

export const STORAGE_KEYS = {
    /** 수수료 관리 필터 */
    FEE_MANAGEMENT_FILTERS: 'feeManagementFilters',
    /** 본사 출금 내역 필터 */
    HEAD_WITHDRAW_FILTERS: 'headWithdrawFilters',
    /** 협력사 일차감 프리필 */
    PARTNER_DEDUCTION_PREFILL: 'partnerDeductionPrefill',
    /** 라이더 선정산 필터 */
    RIDER_PRE_SETTLEMENT_FILTERS: 'riderPreSettlementFilters',
    /** 라이더 주정산 필터 */
    RIDER_SETTLEMENT_FILTERS: 'riderSettlementFilters',
    /** 라이더 출금제한 필터 */
    RIDER_ACCOUNTING_FILTERS: 'riderAccountingFilters',
} as const;

export type StorageKey = typeof STORAGE_KEYS[keyof typeof STORAGE_KEYS];
